import React, { Component } from 'react'
import {Row, Col} from 'react-bootstrap';
import classes from './previewTemplate.module.css'

 class Reusable_Preview extends Component {
    render() {
        return (
            <div>
                     <Row>
                    <Col sm="12">
                    <fieldset className={classes.schedulerBorder}>  
                      {/* <legend className={classes.schedulerBorder}>Job Descriptions</legend> */}
                      <p className={classes.interview} >Job Profile</p>
                      <p><b>Job Title: </b>{this.props.jobProfileId.jobtitle}{this.props.jobProfileId.clientName!=null && this.props.jobProfileId.clientName!=""?" ("+this.props.jobProfileId.clientName+")":null}</p>
                      <p><b>Experience: </b>{this.props.jobProfileId.minExp}-{this.props.jobProfileId.maxExp} {this.props.jobProfileId.maxExp<=1?" year":" years"}</p>
                     {this.props.mode=="interviewDetails"?
                      <p><b>Skills: </b>{this.props.jobProfileId.skills.map((ind)=>ind.value+", ")}</p>:
                      <p><b>Skills: </b>{this.props.jobProfileId.skills}</p>}
                      </fieldset>
                        
                        </Col>
                   
                        <Col sm="12">
                        <fieldset className={classes.schedulerBorder}>  
                      {/* <legend className={classes.schedulerBorder}>Candidate Descriptions</legend> */}
                      <p className={classes.interview} >Candidate Profile</p>
                      <Row>
                          <Col md={5}> <p><b>Full Name: </b>{this.props.candidateId.name}</p></Col>
                          <Col md={7}> <p><b>Email ID: </b> {this.props.candidateId.email}</p></Col>
                      </Row>
                         <Row>
                          <Col md={5}> <p><b>Experience: </b>{this.props.candidateId.experienceInYears}{this.props.candidateId.experienceInYears<=1?" year ":" years "}{this.props.candidateId.experienceInMonths}{this.props.candidateId.experienceInMonths<=1?" month":" months"}</p></Col>
                          <Col md={7}> <p><b>Mobile Number: </b>{this.props.candidateId.mobileCountryCode1}-{this.props.candidateId.phone}</p></Col>
                      </Row>
                      </fieldset>
                       
                      
                        </Col>
                        <Col sm="12">
                        <fieldset className={classes.schedulerBorder}>  
                      {/* <legend className={classes.schedulerBorder}>Interviewer Descriptions</legend> */}
                      <p className={classes.interview} >Interviewer</p>
                      <Row>
                          <Col md={5}><p><b>Full Name: </b>{this.props.interviewerId.name}</p></Col>
                          <Col md={7}> <p><b>Position title: </b><span style={{wordBreak: 'break-all'}}>{this.props.interviewerId.profile}</span></p></Col>
                      </Row>
                      <Row>
                          <Col md={5}><p><b>Experience: </b> {this.props.interviewerId.experienceInYears}{this.props.interviewerId.experienceInYears<=1?" year ":" years "}{this.props.interviewerId.experienceInMonths}{this.props.interviewerId.experienceInMonths<=1?" month":" months"}</p></Col>
                          
                          <Col md={7}> 
                          {this.props.mode!=="interviewDetails"?
                          <p><b>Availability: </b> {this.props.availability}</p>
                          :null}
                          </Col>
                      </Row>
                      
                      </fieldset>
                      
                      
                        </Col>
                        <Col sm="12">
                            <fieldset className={classes.schedulerBorder}>  
                            {/* <legend className={classes.schedulerBorder}>Timing Details</legend> */}
                            <p className={classes.interview} >Invite details</p>
                            <Row>
                                <Col md={5}> <p><b>Interview Date: </b>{this.props.interviewDate}</p></Col>
                                <Col md={6}> <p><b>Interview Time: </b>{this.props.startTime} - {this.props.endTime}</p></Col>
                            </Row>    
                            {/* <Row>
                                <Col md={5}> <p><b>Interview Mode: </b>{this.props.selecttypeofInterviewValue}</p></Col>
                                  </Row>                          */}
                            </fieldset>
                                
                        </Col>
                        </Row>
                       
            </div>
        )
    }
}

export default Reusable_Preview
